import { Website } from "../../types";

export const websiteOrder: Website["id"][] = [
  "altrove",
  "misogi1",
  "steelhead1",
  "tetsuwan",
];
